import React, { Component } from 'react';
import BuildListItem from './build-list-item'
import LinearProgress from 'material-ui/LinearProgress';
import Divider from 'material-ui/Divider';
import CircularProgress from 'material-ui/CircularProgress';
import navList from '../data/nav.json';
import {
    blue700
} from 'material-ui/styles/colors';

const styles = {
    headerText: {
        color: blue700,
    }
};
class BuildList extends Component {
    constructor(props) {
        super(props);
        var newConfig = props.config
        if(!props.config.Prefix)
            newConfig = this.updateConfig(location.pathname.substring(1));
        this.state = { builds: props.builds, config: newConfig, showProgressIndicator : true }
    }

    componentWillReceiveProps(nextProps) {
        //console.log(nextProps.config.Prefix);
        var newConfig = nextProps.config;        
        if(!nextProps.config.Prefix)
            newConfig = this.updateConfig(location.pathname.substring(1));   
        this.setState({
            builds: nextProps.builds,
            showProgressIndicator: nextProps.showProgressIndicator,
            config: newConfig
        })
    }

    updateConfig(path){
        var test = {};           
        navList.forEach(item => {
           item.Branch.forEach(item1 => {
               if(item1.Prefix.toLowerCase().includes(path.toLowerCase().split("/").slice(0,2).join("/"))){                   
                    test = item1;       
                    test.Header = test.Header.split("/")[0] + "/" + path.split("/")[2];   
                    test.Prefix = path;    
                }              
           })
        });               
      return test;

    }

    render() {
        /*
            builds: [{
                buildNumber: 50,
                buildTime: "On: Fri Mar 10 12:46:50 IST 2017",
                url: "https://s3.amazonaws.com/dhg-app-builds/android/5.1/10/Harmony.apk",
                changeLogUrl: "http://mobbuilds.idc.logitech.com:8080/job/Harmony-5.1//all-changes/"
            },
            {
                buildNumber: 51,
                buildTime: "On: Fri Mar 10 12:46:50 IST 2017",
                url: "https://s3.amazonaws.com/dhg-app-builds/android/5.1/10/Harmony.apk",
                changeLogUrl: "http://mobbuilds.idc.logitech.com:8080/job/Harmony-5.1//all-changes/"
            }]
        */
        let { builds, showProgressIndicator, config } = this.state;         
        var buildNumber = parseInt(location.pathname.substring(1).split("/")[3]);        
        
        if(builds && !isNaN(buildNumber))
           builds = builds.filter(item => parseInt(item.buildNumber) == buildNumber);
        else if( !(location.pathname.substring(1).split("/")[3] === "") && config.Prefix.toLowerCase().includes('gold/mw')){
    
            builds = undefined;
        }
            
        
            if (showProgressIndicator === true) {
            return (
                <div className="progress">
                    <CircularProgress size={60} thickness={5}></CircularProgress>
                    {/*<LinearProgress className="progress" height={5} width={100} mode="indeterminate" />*/}
                </div>
            )

        }
        else{
            
            if (!config.Prefix || !builds || (builds.length === 0))
                return (
                    <div className="dashboard-main-page">
                        <div className="dashboard-main-page-heading">Mobile App Builds</div>
                        <span>Please select the branch from the menu to display the builds.
                        </span>
                    </div>
                )
            else {                
                return (
                    <div>
                        <div className="build-list-header" style={styles.headerText}>{config.Header}</div>
                        <Divider></Divider>
                        {
                            builds.map((item) => {
                                let newConfig = Object.assign({},config);

                                //Update Changelogurl
                                if(newConfig.Prefix.toLowerCase().includes('firmware'))
                                    newConfig.ChangeLogUrl = newConfig.ChangeLogUrl + item.buildNumber.split(".")[2];
                                else if(newConfig.Prefix.toLowerCase().includes('pavarotti') || newConfig.Prefix.toLowerCase().includes('goldmw'))
                                    newConfig.ChangeLogUrl = newConfig.ChangeLogUrl + item.buildNumber;  
                                else if(!newConfig.Prefix.toLowerCase().includes('pavarotti')){
                                    newConfig.Prefix = newConfig.Prefix.substring(newConfig.Prefix.indexOf('/') + 1); 
                                }
                                return <BuildListItem key={item.buildNumber} config={newConfig} build={item} />
                            })
                        }
                    </div >
                )
            }

        }
            
    }

}

export default BuildList;


// WEBPACK FOOTER //
// ./src/components/build-list.js